import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  type?: string;
  image?: string;
}

const defaultMeta = {
  title: 'IRL Hosting - Cloud OBS Hosting & SRT/SRTLA Relays for IRL Streamers',
  description: 'Professional cloud OBS hosting for IRL streamers. 24/7 uptime, disconnect protection with BRB scenes, SRT/SRTLA/RIST/RTMP relays. Stream to Twitch, YouTube, Kick, TikTok & more.',
  image: 'https://irlhosting.com/og-image.png',
  siteUrl: 'https://irlhosting.com',
};

export function SEO({ 
  title, 
  description = defaultMeta.description, 
  canonical,
  type = 'website',
  image = defaultMeta.image 
}: SEOProps) {
  const pageTitle = title 
    ? `${title} | IRL Hosting` 
    : defaultMeta.title;
  
  const url = canonical ? `${defaultMeta.siteUrl}${canonical}` : defaultMeta.siteUrl;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
